//
// features-api-service.ts
//
// Copyright (c) 2015 by Curalate, Inc.
//

((() => {
    const angular = window['angular'];
    type IPromise<T> = angular.IPromise<T>;

    angular.module('curalate').service('FeaturesApiService', ['$http', '$q',
        function ($http, $q) {
            const BASE_URL = '/api/features';

            this.asyncGetAllFeatures = () => processResponse(
                 $http.get(
                     `${BASE_URL}/features`
                 )
             );

            this.getHiddenFeaturesAsync = () => processResponse(
                $http.get(
                    `${BASE_URL}/features/hidden`
                )
            );

            this.getClientsWithFeatureAsync = featureId => processResponse(
                $http.get(
                    `${BASE_URL}/features/${featureId}/clients`
                )
            );


            this.asyncGetAllClientFeatureDetails = clientId => processResponse(
                $http.get(
                    `${BASE_URL}/client/${clientId}/features`
                )
            );

            this.getClientDetailsAsync = clientId => processResponse(
                $http.get(
                    `${BASE_URL}/client/${clientId}/clientdetails`
                )
            );

            this.getClientFeatureChanges = (clientId, start, end): IPromise<Array<IClientFeatureChangeDTO>> => {
                const paramString = $.param({
                    start: start,
                    end: end
                });
                return processResponse(
                    $http.get(
                        `${BASE_URL}/client/${clientId}/featureschangelog?${paramString}`
                    )
                ) as angular.IPromise<Array<IClientFeatureChangeDTO>>;
            };

            this.getFeatureTierDiffAsync = (clientId, tierId) => processResponse(
                $http.get(
                    `${BASE_URL}/client/${clientId}/features/tiers/${tierId}/diff`
                )
            );

            this.getFeatureSelectionDiffAsync = (clientId, tiers) => processResponse(
                $http.get(
                    `${BASE_URL}/client/${clientId}/features/tiers/diff?tiers=${tiers.join(',')}`
                )
            );

            this.asyncSetClientFeatureTier = (clientId, tierId) => processResponse(
                $http.post(
                    `${BASE_URL}/client/${clientId}/features/tiers/${tierId}/optin`
                )
            );

            this.asyncSetSelectedTiers = (clientId, tiers) => processResponse(
                $http.post(
                    `${BASE_URL}/client/${clientId}/features/tiers/optin?tiers=${tiers.join(',')}`
                )
            );

            this.asyncSetClientFeatureActionOptin = (clientId, featureId) => processResponse(
                $http.post(
                    `${BASE_URL}/client/${clientId}/feature/${featureId}/optin`
                )
            );

            this.asyncSetClientFeatureValue = (clientId, featureId, featureValue) => {
                const postValue = {
                    value: featureValue,
                };

                return processResponse(
                    $http.post(
                        `${BASE_URL}/client/${clientId}/feature/${featureId}/value`,
                        postValue
                    )
                );
            };

            this.asyncRemoveClientFeatureAction = (clientId, featureId) => processResponse(
                $http.delete(
                    `${BASE_URL}/client/${clientId}/feature/${featureId}/optin`
                )
            );

            this.asyncDeleteClient = clientId => processResponse(
                $http.delete(
                    `${BASE_URL}/client/${clientId}`
                )
            );

            this.asyncFreezeClient = clientId => processResponse(
                $http.put(
                    `${BASE_URL}/client/${clientId}/freeze`
                )
            );

            function processResponse(httpPromise) {
                const deferred = $q.defer();
                httpPromise.then(response => {
                    deferred.resolve(response.data);
                }, response => {
                    const error = response.data;
                    if (typeof error.message !== 'undefined') {
                        deferred.reject(error.message);
                    } else {
                        deferred.reject(error);
                    }
                });
                return deferred.promise;
            }
        }
    ]);
}))();
